import { API_URL, CapitalizeFirstWord } from "../../helpers/utils";
import axios from "../../helpers/axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";
import {
  decryptByText,
  requestPayloadBodyFormate,
  responseDataFormate,
} from "../../helpers/bycrypt";
import { NavigateFunction } from "react-router-dom";
import axiosInstance from "../../helpers/axios";
import {
  formatAttributes,
  transformItemsByVariant,
} from "../Pages/Orders/orderTypes";

const API_BASE_URL = `${API_URL}`;

export const GetUnreadNotificationCountAPI =
  (params?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getNotificationCount", true);

    axiosInstance
      .get(`/notifications/unread/count`, {
        params: params || {},
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_NOTIFICATION_COUNT",
            payload: result?.data?.unread_count,
          });

          dispatchLoading(dispatch, "getNotificationCount", false);
        } else elseHandler(dispatch, "getNotificationCount", result);
        dispatchLoading(dispatch, "getNotificationCount", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getNotificationCount")(err);
        // navigate("/auth/login");
      });
  };

export const GetNotificationSettingAPI =
  () => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getNotificationSetting", true);

    axiosInstance
      .get(`/email-notification-template/settings`, {
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_NOTIFICATION_SETTING_DATA",
            payload: result?.data,
          });

          dispatchLoading(dispatch, "getNotificationSetting", false);
        } else elseHandler(dispatch, "getNotificationSetting", result);
        dispatchLoading(dispatch, "getNotificationSetting", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getNotificationSetting")(err);
        // navigate("/auth/login");
      });
  };

export const GetNotificationDataAPI =
  ({ page, limit, app }: any, setHasMore: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getNotificationData", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (app) params["app"] = app;
    axiosInstance
      .get(`/notifications`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_NOTIFICATION_DATA",
            payload: {
              data: result?.data?.notifications,
              page: page,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.notifications?.length == limit);
          }
          dispatchLoading(dispatch, "getNotificationData", false);
        } else elseHandler(dispatch, "getNotificationData", result);
        dispatchLoading(dispatch, "getNotificationData", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getNotificationData")(err);
        // navigate("/auth/login");
      });
  };

export const UpdateNotificationReadAPI =
  (id: any, onClose: any, isRead: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "readNotification", true);
    axios
      .put(`/notifications/${id}/read`, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) {
            onClose();
          }
          dispatch({
            type: "READ_NOTIFICATION",
            payload: { id: id, isRead: isRead },
          });
          // dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "readNotification", undefined);
        } else elseHandler(dispatch, "readNotification", result);
        dispatchLoading(dispatch, "readNotification", false);
      })
      .catch(catchHandler(dispatch, "readNotification"));
  };

export const UpdateReadAllNotificationAPI =
  (payload?: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "readAllNotification", true);
    axios
      .put(`/notifications/read-all`, payload || {}, {
        params: payload?.app ? { app: payload.app } : {},
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "READ_ALL_NOTIFICATION",
            payload: result?.data,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "readAllNotification", undefined);
        } else elseHandler(dispatch, "readAllNotification", result);
        dispatchLoading(dispatch, "readAllNotification", false);
      })
      .catch(catchHandler(dispatch, "readAllNotification"));
  };

export const UpdateNotificationSettingAPI =
  (payload: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updateNotificationSetting", true);
    axios
      .put(`/email-notification-template/settings`, payload, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          dispatch({
            type: "UPDATE_NOTIFICATION_SETTING",
            payload: result?.data,
          });
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updateNotificationSetting", undefined);
        } else elseHandler(dispatch, "updateNotificationSetting", result);
        dispatchLoading(dispatch, "updateNotificationSetting", false);
      })
      .catch(catchHandler(dispatch, "updateNotificationSetting"));
  };

export const getQueueListAPI =
  ({ page, limit }: any, setHasMore: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getQueueList", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    axiosInstance
      .get(`/batch-process/import`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
         
          dispatch({
            type: "GET_QUEUE_LIST",
            payload: {
              data: result?.data?.data,
              count:result?.data?.count,
              page: page,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getQueueList", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getQueueList", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getQueueList")(err);
        // navigate("/auth/login");
      });
  };


  export const getExportQueueListAPI =
  ({ page, limit }: any, setHasMore: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getExportQueueList", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    axiosInstance
      .get(`/batch-process/export`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
         
          dispatch({
            type: "GET_EXPORT_QUEUE_LIST",
            payload: {
              data: result?.data?.data,
              count:result?.data?.count,
              page: page,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
        } else {
          elseHandler(dispatch, "getExportQueueList", result);
          // navigate("/auth/login");
        }
        dispatchLoading(dispatch, "getExportQueueList", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getExportQueueList")(err);
        // navigate("/auth/login");
      });
  };



export const cancleImportProgressAPI =
  (payload: any, callback?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "cancleImportProgress", true);
    axiosInstance
      .post(`/batch-process/import/cancel`, payload)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({type:"CANCLE_IMPORT_PROGRESS",payload:payload?.id})
          if (callback) callback(result?.data);
          dispatchLoading(dispatch, "cancleImportProgress", false);
        } else elseHandler(dispatch, "cancleImportProgress", result);
        dispatchLoading(dispatch, "cancleImportProgress", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "cancleImportProgress")(err);
        dispatchLoading(dispatch, "cancleImportProgress", false);
      });
  };


export const cancleExportProgressAPI =
  (payload: any, callback?: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "cancleExportProgress", true);
    axiosInstance
      .post(`/batch-process/export/cancel`, payload)
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({type:"CANCLE_EXPORT_PROGRESS",payload:payload?.id})
          if (callback) callback(result?.data);
          dispatchLoading(dispatch, "cancleExportProgress", false);
        } else elseHandler(dispatch, "cancleExportProgress", result);
        dispatchLoading(dispatch, "cancleExportProgress", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "cancleExportProgress")(err);
        dispatchLoading(dispatch, "cancleExportProgress", false);
      });
  };